import React from 'react';
import {
	BooleanInput,
	Edit,
	SelectInput,
	SimpleForm,
	TextInput,
} from 'react-admin';
import { Grid } from '@mui/material';

const featureTypeChoices = [
	{ id: 'boolean', name: 'Boolean' },
	{ id: 'quantity', name: 'Quantity' },
	{ id: 'enum', name: 'Enum' },
];

export const FeatureEdit = (props: any) => (
	<Edit {...props}>
		<SimpleForm>
			<Grid container spacing={2}>
				<Grid item xs={6}>
					<TextInput source="id" disabled />
					<TextInput source="slug" required />
					<TextInput source="name" required />
					<SelectInput source="type" choices={featureTypeChoices} required />
					<TextInput source="stripeProductId" label="Stripe Product ID" />
					<BooleanInput label="Enabled" source="enabled" />
				</Grid>
			</Grid>
		</SimpleForm>
	</Edit>
);
